import React from "react";
import { ProudToServeLogo } from "./ProudToServeLogo";

export function ProudToServe() {
	return (
		<section className="section--proud-to-serve container">
			<p>Proud to serve</p>

			<ul className="grid justify-space-between">
				<ProudToServeLogo
					companyName="United Airlines"
					fileName="logo-united.svg"
					link="https://www.united.com/"
				/>
				<ProudToServeLogo
					companyName="Airbus"
					fileName="logo-airbus.svg"
					link="https://www.airbus.com/"
				/>
				<ProudToServeLogo
					companyName="IATA"
					fileName="logo-iata.svg"
					link="https://www.iata.org/"
				/>
				<ProudToServeLogo
					companyName="AerCap"
					fileName="logo-aercap.svg"
					link="https://www.aercap.com/"
				/>
				<ProudToServeLogo
					companyName="Air Charter Service"
					fileName="logo-air-charter-service.png"
					link="https://www.aircharterservice.com/group-charter/aircraft-leasing"
				/>
				<ProudToServeLogo
					companyName="AAR"
					fileName="logo-aar.svg"
					link="https://www.aarcorp.com/"
				/>
				<ProudToServeLogo
					companyName="Fraport"
					fileName="logo-fraport.svg"
					link="https://www.fraport.com/"
				/>
				<ProudToServeLogo
					companyName="Amadeus"
					fileName="logo-amadeus.svg"
					link="ttps://amadeus.com/"
				/>
			</ul>
		</section>
	);
}
